import { DatePickerElement } from 'react-hook-form-mui/date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { Stack } from '@mui/material';
import { SxProps } from '@mui/material';

type Props = {
  name?: string;
  format?: string;
  fullWidth?: boolean;
  sx?: SxProps;
  size?: "small" | "medium";
};

export default function RHFDateRangePicker({
  name,
  format = 'dd-MM-yyyy',
  fullWidth = false,
  sx,
  size = "medium"
}: Props) {

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Stack direction="row" gap={2} width={fullWidth ? '100%' : 'auto'} sx={sx}>
        <DatePickerElement
          label="Start Date"
          format={format}
          name={name ? `${name}.start_date` : 'start_date'}
          sx={{
            '& .MuiInputBase-root': {
              height: size === "small" ? 38 : 54,
              display: 'flex',
              alignItems: 'center',
            },
            '& .MuiInputBase-input': {
              height: 'auto',
            },
            '& .MuiInputLabel-root': {
              transform: size === "small" ? 'translate(14px, 9px) scale(1)' : undefined,
            },
            '& .MuiInputLabel-root.MuiInputLabel-shrink': {
              transform: size === "small" ? 'translate(14px, -9px) scale(0.75)' : undefined,
            },
          }}
        />
        <DatePickerElement
          label="End Date"
          format={format}
          name={name ? `${name}.end_date` : 'end_date'}
          sx={{
            '& .MuiInputBase-root': {
              height: size === "small" ? 38 : 54,
              display: 'flex',
              alignItems: 'center',
            },
            '& .MuiInputBase-input': {
              height: 'auto',
            },
            '& .MuiInputLabel-root': {
              transform: size === "small" ? 'translate(14px, 9px) scale(1)' : undefined,
            },
            '& .MuiInputLabel-root.MuiInputLabel-shrink': {
              transform: size === "small" ? 'translate(14px, -9px) scale(0.75)' : undefined,
            },
          }}
        />
      </Stack>
    </LocalizationProvider>
  );
}
